/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for cardinalityEnum. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="cardinalityEnum"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="zero"/&gt; &lt;enumeration value="one"/&gt; &lt;enumeration value="many"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class CardinalityEnum extends Enum{

	enumValue = null;

	/**
	 * Specifies that this object has no rows.
	 */
	static  ZERO = CardinalityEnum.newLiteral("zero");

	/**
	 * Specifies that this object has one row only.
	 */
	static  ONE = CardinalityEnum.newLiteral("one");

	/**
	 * Specifies that this object can have many rows.
	 */
	static  MANY = CardinalityEnum.newLiteral("many");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < CardinalityEnum.values().length); ++i) {
			if (CardinalityEnum.values()[i].enumValue == v) {
				return CardinalityEnum.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("CardinalityEnum" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/CardinalityEnum.js